import type { ReactNode } from "react";
import { isAxiosError } from "axios";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DetailError({
  invalid,
  error,
  backTo,
  onRetry,
}: {
  invalid?: boolean;
  error?: unknown;
  backTo: string;
  onRetry: () => void;
}) {
  const notFound = invalid || (isAxiosError(error) && error.response?.status === 404);
  return (
    <div role="alert" className="space-y-3 py-6">
      <p>{notFound ? "Élément introuvable." : "Impossible de charger les détails."}</p>
      <div className="flex gap-3 items-center">
        <Link to={backTo} className="underline">
          Retour à la liste
        </Link>
        {!notFound && <Button onClick={onRetry}>Réessayer</Button>}
      </div>
    </div>
  );
}

type QueryStatus = { isPending: boolean; isError: boolean; refetch: () => unknown };

export function QuerySection({
  query,
  label,
  children,
}: {
  query: QueryStatus;
  label: string;
  children: ReactNode;
}) {
  if (query.isError)
    return (
      <div role="alert" className="p-4 space-y-2 text-sm">
        <p>{label} : données indisponibles.</p>
        <Button variant="outline" size="sm" onClick={() => void query.refetch()}>
          Réessayer
        </Button>
      </div>
    );
  if (query.isPending)
    return (
      <div role="status" className="flex gap-2 items-center p-4 text-sm">
        <Loader2 className="animate-spin" size={16} /> Chargement : {label}…
      </div>
    );
  return <>{children}</>;
}
